import {FC} from 'react';

import {useCookies} from 'libs/cookie/useCookies';
import {IS_VISIBLE_PRIVACY_POLICY} from './constants/cookies';

type PropsType = {
    children: JSX.Element;
};

/**
 *  Experiment for having one popup for prescription instructions instead of 5 small ones
 * @params {PropsType} props - props
 * @return {JSX.Element} - PrescriptionPopup component
 */
export const PrivacyPolicyWrapper: FC<PropsType> = ({children}) => {
    const [cookies] = useCookies();
    const isEnabledPrivacyPolicyCookie = Boolean(cookies[IS_VISIBLE_PRIVACY_POLICY]);

    if (isEnabledPrivacyPolicyCookie) return null;

    return children;
};
